module.exports = __webpack_public_path__ + "static/6_icon_aufenthaltsqualitat-gastro-5fc4c8d22df1f6d240ad7e8ea2e1af66.png";